'use strict';
import personAccordion from '../../common/person-accordion';
var SearchView = require('../../common/views/search-view');

module.exports = function () {


    var searchView = new SearchView();

    // Here your client js
    personAccordion.init();
};
